module.exports = __webpack_public_path__ + "img/pain-spot-8.1be664f4.svg";